import { type CollectibleEventListRefined } from '@capsicum/common';
import { CardCarousel, useRouter } from '@capsicum/common-web';
import { auctionsUtils } from '@capsicum/features/fanshop/shared';
import { useCallback } from 'react';
import styled from 'styled-components';

import { AuctionCard, ITEM_WIDTH } from '../auction-card/AuctionCard';

type AuctionCardCarouselProps = {
	event: CollectibleEventListRefined;
};

export const AuctionCardCarousel = ({ event }: AuctionCardCarouselProps) => {
	const { getAwayTeam, getHomeTeam } = auctionsUtils();
	const router = useRouter();

	const homeTeam = getHomeTeam(event);
	const awayTeam = getAwayTeam(event);

	const renderAuctions = useCallback(
		(event: CollectibleEventListRefined) =>
			event.auctions?.map(auction => (
				<AuctionCard
					auction={auction}
					key={auction.id}
					testID={`auction-card-${auction.id}`}
					onClick={() => router.push(`/fan-shop/rewards/auction/${auction.id}`)}
				/>
			)),
		[router]
	);

	return (
		<S.Wrapper>
			<S.TitleContainer>
				{homeTeam && <S.Title>{`${homeTeam} -`}</S.Title>}
				{awayTeam && <S.Subtitle>{awayTeam}</S.Subtitle>}
			</S.TitleContainer>
			<CardCarousel cardWidth={ITEM_WIDTH} testID={`event-${event.id}`} variant="fullWidth">
				{renderAuctions(event)}
			</CardCarousel>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const TitleContainer = styled.div`
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const Title = styled.span`
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Subtitle = styled.span`
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.unselected};
	`;
}
